<template>
  <v-container class="test_red">
    <v-row justify="center" no-gutters class="test_blue">
      <v-col cols="12" md="10" lg="8" class="test_yellow">
        <v-list v-if="$store.getters.isLoading">
          <v-list-item class="list-group-item my-2 px-5">
            <v-list-item-content>
              <v-skeleton-loader type="list-item-avatar-two-line" />
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list v-else>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            class="list-group-item my-2 px-5"
          >
            <v-list-item-icon class="mx-0 mr-4 d-flex align-self-center">
              <v-icon
                large
                color="primary"
                v-text="
                  item.addressTitle == 'Home' ? types[0].icon : types[1].icon
                "
              />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <span class="title">
                  {{ item.addressTitle }}
                </span>
                <v-chip
                  v-if="item.isDefault"
                  class="ml-5"
                  label
                  color="primary"
                  v-text="$t('general.default')"
                />
              </v-list-item-title>
              <v-list-item-title>
                <span class="address">
                  {{ item.prettyAddress }}
                </span>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action v-ripple>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon v-text="'mdi-dots-vertical-circle-outline'" />
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item-group color="primary">
                    <v-list-item @click="setDefault(item)">
                      <v-list-item-title
                        v-text="$t('customerProfile.setAsDefault')"
                      />
                    </v-list-item>
                    <v-list-item @click="showEdit(item.id)">
                      <v-list-item-title v-text="$t('general.edit')" />
                    </v-list-item>
                    <v-list-item @click="deleteAddressBook(item)">
                      <v-list-item-title v-text="$t('general.delete')" />
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row justify="center" no-gutters class="test_blue">
      <v-btn x-large color="primary" rounded @click="dialog = true">
        <v-icon left v-text="'mdi-plus'" />
        <span class="btn" v-text="$t('customerProfile.addAddress')" />
      </v-btn>
    </v-row>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      max-width="550"
      transition="dialog-bottom-transition"
      content-class="dialog-rounded"
      :scrollable="true"
    >
      <card-modal>
        <template v-slot:header>
          <span
            class="title-modal-card"
            v-text="
              idAddressBook
                ? $t('customerProfile.editAddress')
                : $t('customerProfile.addAddress')
            "
          />
          <v-spacer></v-spacer>
          <v-btn icon x-large @click="dialog = false">
            <v-icon x-large color="primary" v-text="'mdi-close'" />
          </v-btn>
        </template>
        <template v-slot:body>
          <FormAddressComponent :id="idAddressBook" v-model="formAddress" />
        </template>
        <template v-slot:actions>
          <v-col>
            <ButtonSuccess
              :valid="formAddress == false ? false : true"
              @click="saveAddressBook()"
            />
          </v-col>
        </template>
      </card-modal>
    </v-dialog>
  </v-container>
</template>

<script>
import FormAddressComponent from "./FormAddressComponent.vue";
export default {
  name: "AddressBook",
  components: {
    FormAddressComponent,
  },
  data: () => ({
    idAddressBook: null,
    items: null,
    dialog: false,
    formAddress: false,
    showAddressError: false,
    types: [
      { name: "Home", icon: "mdi-home" },
      { name: "Office", icon: "mdi-city" },
    ],
  }),

  watch: {
    dialog: function () {
      if (!this.dialog) {
        this.idAddressBook = null;
      }
    },
  },
  mounted() {
    this.loadAddressBook();
  },
  methods: {
    loadAddressBook: async function () {
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await axios.get("/users/profiles/address/book");
      self.items = data.data;
      self.$store.dispatch("loading/done");
    },
    saveAddressBook: async function () {
      const self = this;
      self.$store.dispatch("loading/start");
      if (self.idAddressBook) {
        const { data } = await self.formAddress.post(
          "/users/profiles/address/book"
        );
        Toast.fire({
          icon: "success",
          title: data.message,
        });
      } else {
        const { data } = await self.formAddress.post(
          "/users/profiles/address/book"
        );
        Toast.fire({
          icon: "success",
          title: data.message,
        });
      }

      self.loadAddressBook();

      self.dialog = false;
    },
    deleteAddressBook: async function (datas) {
      const self = this;
      const { value: result } = await Swal.fire({
        title: self.$t("general.delete"),
        html:
          self.$t("customerProfile.deleteAddress") +
          "<b> " +
          datas.prettyAddress +
          "</b>?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      if (result) {
        self.$store.dispatch("loading/start");
        const { data } = await axios.delete(
          "/users/profiles/address/book/" + datas.id
        );
        Toast.fire({
          icon: "success",
          title: data.message,
        });
        self.loadAddressBook();
      }
    },
    showEdit: async function (id) {
      const self = this;
      self.dialog = true;
      self.idAddressBook = id;
    },
    setDefault: async function (datas) {
      const self = this;
      let form = new Form({
        addressBookId: datas.id,
      });
      self.$store.dispatch("loading/start");
      self.selected = null;
      const { data } = await form.post("/users/profiles/default/address");
      Toast.fire({
        icon: "success",
        title: data.message,
      });
      self.loadAddressBook();
    },
  },
};
</script>
<style lang="scss">
.list-group-item {
  height: 100%;
  border: solid;
  border-color: rgba($color: #aaa, $alpha: 0.5);
  border-width: 0.5px;
  cursor: pointer !important;
  border-radius: 10px;
}
.form-background {
  background-color: rgba(170, 170, 170, 0.342);
}
.title {
  font-size: 1.5rem;
  font-family: $font_Bold;
}
.address {
  font-size: 1rem;
  color: #aaa;
}
.type-title {
  font-size: 1rem;
}
</style>
